/* eslint-disable view-models/no-unused-meta */
/* eslint-disable react/prop-types */
// TODO: remove view-models/no-unused-meta and eslint-disable react/prop-types
import React from 'react';
import PropTypes from 'prop-types';
import FilterItem from 'components/models/filter-item';
import cn from 'classnames';
import Icon from 'components/icon';
import TextSkeleton from 'components/text-skeleton';

const TagsFilterItem = ({
  color,
  text,
  value,
  selected = false,
  asSkeleton,
  itemCountPlaceholder,
  onClick = () => {},
  className,
}) => {
  var buttonStyle = {
    backgroundColor: color,
  };

  return (
    <button
      defaultValue={value}
      className={cn('tags-filter-item', className, {
        'tags-filter-item_selected': selected,
        'tags-filter-item_skeleton': asSkeleton,
      })}
      onClick={() => onClick()}
      style={buttonStyle}
    >
      <span className="tags-filter-item__content">
        {selected && <Icon name="check" className="tags-filter-item__icon" />}
        <span className="tags-filter-item__text">{text}</span>
        {asSkeleton && itemCountPlaceholder && (
          <span className="tags-filter-item__text-count-placeholder">
            &nbsp;{itemCountPlaceholder}
          </span>
        )}
      </span>
      {asSkeleton && (
        <TextSkeleton
          className="tags-filter-item__text-skeleton"
          maxLines={1}
        />
      )}
    </button>
  );
};

TagsFilterItem.propTypes = Object.assign({}, FilterItem.propTypes, {
  color: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  asSkeleton: PropTypes.bool,
  className: PropTypes.string,
  itemCountPlaceholder: PropTypes.string,
});

TagsFilterItem.viewModelMeta = {
  className: 'ignore',
  asSkeleton: 'ignore',
  itemCountPlaceholder: 'ignore',
};

export default TagsFilterItem;
